import { useState } from 'react';
import { JIRA_PROJECTS_MODEL } from '../jiraStats.model';

const DIRS = {
  ASC: 'asc',
  DESC: 'desc'
};

export const DEFAULT_SORT_BY = {
  key: JIRA_PROJECTS_MODEL.EFFORT,
  dir: DIRS.DESC
};

const useTableSortBy = () => {
  const [tableSortBy, setTableSortBy] = useState(DEFAULT_SORT_BY);

  const onChange = ({ key, dir }) => setTableSortBy({ key, dir });

  return {
    ...tableSortBy,
    onChange
  };
};

export default useTableSortBy;
